import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { ModalLock } from '../modal-lock'
import { PaywallLock } from '../paywall-lock'
import {
  DoctrineOneOfferLock_OfferLockDataFragment,
  DoctrineOneOfferLock_ViewerFragment,
} from './__generated__/doctrine-one-offer-lock.graphql'
import styles from './doctrine-one-offer-lock.module.scss'
import { DoctrineOneOfferLockLoggedContent } from './doctrine-one-offer-lock-logged-content'
import { DoctrineOneOfferLockUnloggedContent } from './doctrine-one-offer-lock-unlogged-content'

export interface DoctrineOneOfferLockProps {
  offerLockData: DoctrineOneOfferLock_OfferLockDataFragment
  viewer?: DoctrineOneOfferLock_ViewerFragment
}

export function DoctrineOneOfferLock({ offerLockData, viewer }: DoctrineOneOfferLockProps) {
  const { componentType } = useContext(BoxLockContext)
  const content = viewer ? (
    <DoctrineOneOfferLockLoggedContent viewer={viewer} offerLockData={offerLockData} />
  ) : (
    <DoctrineOneOfferLockUnloggedContent offerLockData={offerLockData} />
  )

  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles['paywall-doctrine-lock']}>
          {content}
        </PaywallLock>
      )
    case 'modal':
      return (
        <ModalLock size="sm" offerLockBody={offerLockData.body}>
          {content}
        </ModalLock>
      )
    default:
      return null
  }
}

DoctrineOneOfferLock.fragments = {
  offerLockData: gql`
    fragment DoctrineOneOfferLock_offerLockData on OfferLockData {
      ...DoctrineOneOfferLockLoggedContent_offerLockData
      ...DoctrineOneOfferLockUnloggedContent_offerLockData
      ...PaywallLock_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${DoctrineOneOfferLockLoggedContent.fragments.offerLockData}
    ${DoctrineOneOfferLockUnloggedContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment DoctrineOneOfferLock_viewer on Profile {
      ...DoctrineOneOfferLockLoggedContent_viewer
    }
    ${DoctrineOneOfferLockLoggedContent.fragments.viewer}
  `,
}
